import http from '@utils/http';

// 绑定工位信息
export const bindSeat = function (options) {
  return http.post('/api/online-station-stage/extranet/bindSeat', options);
};
// 根据城市查职场
export function getCityCodeList(params) {
  return http.get('/api/online-station-stage/extranet/cityCode', {
    params,
  });
}
// 查询用户详情
export function getUserDetail(params) {
  return http.get('/api/online-station-stage/extranet/detail', {
    params,
  });
}
// 根据职场和部门查询工位列表
export function getSeatList(params) {
  return http.get('/api/online-station-stage/extranet/seat/list', {
    params,
  });
}
// 根据字典查询城市列表
export function getCityList(params) {
  return http.get('/api/online-station-stage/extranet/getCityList', {
    params,
  });
}
// 检查工位情况
export function checkSeat(params) {
  return http.get('/api/online-station-stage/extranet/checkSeat', {
    params,
  });
}
